import { useState } from 'react';

import { useActivityBuilderContext } from '../activity-builder.context';
import {
  ActivityBuilderDrawerContent,
  ActivityBuilderDrawerHeader,
  ActivityBuilderDrawerWrapper,
} from '../activity-builder-drawer';
import {
  InquisitiveActivitiesContentStatus,
  InquisitiveActivitiesContentType,
} from 'global/graphql/scalars.type';
import {
  DraftAssessmentActivities,
  DraftLessonActivities,
} from '../activity-builder-draft.constants';
import { TabsWrapper } from 'approot/shared/tabs/tabs.style';
import Tabs from 'approot/shared/tabs/tabs';
import SettingsPublish from './publish/settings-publish';
import SettingsDrawerVersionHistory from './publish/settings-drawer-version-history';

const TABS = [
  {
    label: 'Publishing',
    value: 'publishing',
  },
  {
    label: 'Version History',
    value: 'version-history',
  },
];

type Props = {
  contentId: number;
  contentType: InquisitiveActivitiesContentType;
  status: InquisitiveActivitiesContentStatus;
  hasUnpublishedChanges: boolean;
  activities: DraftLessonActivities | DraftAssessmentActivities;
};

const SettingsDrawerGlobal = ({
  contentId,
  contentType,
  status,
  hasUnpublishedChanges,
  activities,
}: Props) => {
  const { closeDrawer } = useActivityBuilderContext();

  const [selectedTab, setSelectedTab] = useState<string>(TABS[0].value);

  return (
    <ActivityBuilderDrawerWrapper>
      <ActivityBuilderDrawerHeader title="Settings" onClose={closeDrawer} />
      <TabsWrapper>
        <Tabs
          options={TABS}
          activeTab={selectedTab}
          onSelect={option => setSelectedTab(option.value as string)}
          contentPanelId="settings-publish-tabs"
          ariaDescription="Settings publish tabs"
        />
      </TabsWrapper>
      <ActivityBuilderDrawerContent id="settings-publish-tabs">
        {selectedTab === TABS[0].value && (
          <SettingsPublish
            contentId={contentId}
            contentType={contentType}
            status={status}
            hasUnpublishedChanges={hasUnpublishedChanges}
            activities={activities}
          />
        )}
        {selectedTab === TABS[1].value && (
          <SettingsDrawerVersionHistory contentId={contentId} />
        )}
      </ActivityBuilderDrawerContent>
    </ActivityBuilderDrawerWrapper>
  );
};

export default SettingsDrawerGlobal;
